export const BASE_RENTAL_APPLICATION_PATH = '/tempe/apply'
export const RENTAL_APPLICATION_URLS = {
  UNIT_SELECTION_URL: `${BASE_RENTAL_APPLICATION_PATH}/unit-selection/`,
}
